import type { ReactElement } from "react"
import AlignContentOrg from "@onestore/hel/dist/components/organisms/AlignContentOrg"
import BaseContainer from "@gatsby-plugin-generic-page/components/BaseContainer"
import BaseSection from "@gatsby-plugin-generic-page/components/BaseSection"
import Header from "@gatsby-plugin-generic-page/components/Header"
import type { FaqSectionFlatData } from "@gatsby-plugin-generic-page/fragments/faqSection"
import FaqContent from "~/components/FaqContent"
import isEmpty from "~/lib/isEmpty"

export default function FaqSection({
  header,
  faqs,
  sectionSettings,
}: FaqSectionFlatData): ReactElement {
  return (
    <BaseSection
      {...sectionSettings}
      role="region"
      aria-label="Frequently Asked Questions"
    >
      <BaseContainer {...sectionSettings?.containerSettings}>
        {!isEmpty(header) ? (
          <div className="mb-7">
            <AlignContentOrg horizontalAlign="center">
              <Header {...header} />
            </AlignContentOrg>
          </div>
        ) : null}

        <AlignContentOrg horizontalAlign="left" horizontalAlignType="text">
          <FaqContent faqs={faqs} hasFaqSchema />
        </AlignContentOrg>
      </BaseContainer>
    </BaseSection>
  )
}
